import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import EventsTimeLine from "./EventsTimeLine";
import MyPagination from "../Common/MyPagination";
import { useDispatch } from "react-redux";
import { mapsAPI } from "../store/slices/mapsSlice";
import { useGetEventsQuery } from "../store/slices/settingsSlice";
import MapAssetsSlider from "./MapAssetsSlider";
import EventCloseEventModal from "./EventCloseEventModal";

function LiveEventList({
  assetUuid,
  activeEventsOnly,
  eventSolution,
  filters,
}) {
  const [pagination, setPagination] = useState({
    offset: 0,
    perPage: 12,
  });
  const { data: { events, total } = { events: [], total: 0 }, refetch } =
    useGetEventsQuery({
      ...pagination,
      ...(assetUuid && { assets: [assetUuid] }),
      ...(activeEventsOnly && { status: "active" }),
      ...(eventSolution && { solutionClientUuid: eventSolution.Uuid }),
      ...filters,
    });
  const dispatch = useDispatch();
  const handleEventClosed = () => {
    refetch();
    dispatch(mapsAPI.util.invalidateTags(["Locations"]));
  };
  return (
    <div>
      <div className="p-3 rounded-3 bg-white">
        <table className="table mt-3">
          <thead>
            <tr>
              <th>Reference</th>
              <th>User Reference</th>
              <th>Status</th>
              <th>Severity</th>
              <th>Solution Name</th>
              <th>Assets</th>
              <th>Started At</th>
              <th>
                <div className="d-flex justify-content-between align-items-end">
                  End At{" "}
                  <button onClick={() => refetch()} className="btn btn-sm">
                    <FontAwesomeIcon icon={faRotateLeft} />
                  </button>
                </div>{" "}
              </th>
            </tr>
          </thead>
          <tbody>
            {(events || []).map((item, i) => (
              <tr key={i}>
                <td>
                  <div className="d-flex gap-2">
                    <EventsTimeLine
                      eventUuid={item.Uuid}
                      eventSolution={eventSolution}
                      label={item.Reference}
                    />{" "}
                    <MapAssetsSlider
                      item={item}
                      eventSolution={eventSolution}
                      isEventLocations
                    />
                  </div>
                </td>
                <td>
                  {item.UserReference || (
                    <span className="text-muted fw-lighter">N/A</span>
                  )}
                </td>

                <td>
                  <span
                    className={`badge rounded-pill ${
                      item.Status === "active"
                        ? "bg-danger"
                        : item.Status === "closed"
                        ? "bg-secondary"
                        : item.Status === "resolved"
                        ? "bg-success"
                        : item.Status === "creating"
                        ? "bg-warning"
                        : ""
                    }`}
                  >
                    {item.Status}
                    {item.Status === "creating" ? (
                      <FontAwesomeIcon
                        size="sm"
                        className="ms-2"
                        icon={faSpinner}
                        spin
                      />
                    ) : null}
                  </span>
                </td>
                <td>
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor:
                        item.Severity === "critical"
                          ? "red"
                          : item.Severity === "high"
                          ? "orange"
                          : item.Severity === "medium"
                          ? "gold"
                          : "seagreen",
                    }}
                  >
                    {item.Severity}
                  </span>
                </td>
                <td>
                  {item.SolutionClient?.SolutionName || (
                    <span className="text-muted fw-lighter">N/A</span>
                  )}
                </td>

                <td>{item.AssetsCount || 0}</td>

                <td>{new Date(item.StartAt).toLocaleString()}</td>
                <td>
                  {item.EndAt.Valid ? (
                    new Date(item.EndAt.Time).toLocaleString()
                  ) : (
                    <EventCloseEventModal
                      eventData={item}
                      eventSolution={item.SolutionClient || {}}
                      onClosed={handleEventClosed}
                      label="Stop Now"
                      buttonClassName="btn btn-sm btn-outline-danger"
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <MyPagination
          total={total}
          onPaginate={(page, perPage) => {
            setPagination((p) => ({ ...p, page, perPage }));
          }}
        />
      </div>
    </div>
  );
}

export default LiveEventList;
